import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import { mapState } from 'vuex';
import { themesMixin, vuetifyColors } from '../../../utils/themes.js';
import { localizeDate as _localizeDate, gatewayMgmtMixin, userItemsPerListMixin, isCopyToClipboardSupported, copyToClipboard as _copyToClipboard } from '@/utils/vuex';
import listMixin from '../listMixin';
import listOptionsPersistenceMixin from '../../custom/listOptionsPersistenceMixin';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicGwMgmtList',
  mixins: [gatewayMgmtMixin, themesMixin, listMixin, listOptionsPersistenceMixin, userItemsPerListMixin],
  props: {
    accountId: {
      type: Number,
      required: false,
      default: undefined
    },
    filterWarning: {
      type: Boolean,
      required: false,
      default: false
    },
    filterAlert: {
      type: Boolean,
      required: false,
      default: false
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      isFetching: false,
      tableOptions: _objectSpread({}, defaultTableOptions),
      defaultTableOptions: _objectSpread({}, defaultTableOptions),
      priorRequestOptions: null,
      serverItemsLength: 0,
      gateways: [],
      expandedItems: [],
      deletePrompt: false,
      selectedItem: {},
      disableFetchOnCreatedMixin: true,
      searchItem: null,
      selectedAccount: null,
      listPersistencePath: 'GWMgmt.list',
      searchMode: 'single',
      accountsMode: 'single',
      includeSubAccounts: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'refreshGMMinutes'])), {}, {
    isIotHubManager: function isIotHubManager() {
      return this.permissions['IotHub.manage'];
    },
    isAdmin: function isAdmin() {
      return this.permissions['all.manage'];
    },
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          sortable: false
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.id'),
          value: 'id',
          align: 'right'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.title'),
          value: 'title'
        }, {
          text: this.$i18n_t('NiotaClassic.GWMonitoring.gwEui'),
          value: 'eui'
        }, {
          text: this.$i18n_t('NiotaClassic.GWMonitoring.status'),
          value: 'status',
          sortable: false
        }, {
          text: this.$i18n_t('NiotaClassic.DeviceMonitoring.lastPacket'),
          value: 'createdAt',
          sortable: false
        }, {
          text: this.$i18n_t('NiotaClassic.Devices.table.rssi'),
          value: 'rssi',
          sortable: false
        }, {
          text: this.$i18n_t('NiotaClassic.GWMonitoring.account'),
          value: 'accountTitle',
          sortable: true
        }, {
          text: this.$i18n_t('NiotaClassic.GWMonitoring.form.group'),
          value: 'group',
          sortable: true
        }, {
          sortable: false
        }],
        tableFooterProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        }
      };
    }
  }),
  watch: {
    accountId: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }

      this.fetchList();
    }, 500),
    filterWarning: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }

      this.fetchList();
    }, 500),
    filterAlert: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }

      this.fetchList();
    }, 500),
    includeSubAccounts: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }

      this.fetchList();
    }, 500),
    refreshGMMinutes: function refreshGMMinutes(newValue) {
      var _this = this;

      if (this.isFetching) {
        return;
      }

      this.clearGMInterval(this.intervalId);

      if (newValue > 0) {
        var seconds = this.convertMinutesToSeconds(newValue);
        this.intervalId = setInterval(function () {
          _this.fetchList();
        }, seconds * 1000);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearGMInterval(this.intervalId);
  },
  created: function created() {
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  methods: {
    initializedDefaultPageFilters: function initializedDefaultPageFilters() {
      var filterWarning = get(this.$store.state.app, "pageFilters.".concat(this.listPersistencePath, ".filterWarning")) || false;
      var filterAlert = get(this.$store.state.app, "pageFilters.".concat(this.listPersistencePath, ".filterAlert")) || false;
      this.includeSubAccounts = get(this.$store.state.app, "pageFilters.".concat(this.listPersistencePath, ".includeSubAccounts"), true) || false; // parent should trigger a `fetchList` in @loaded-config

      this.$emit('loaded-config', {
        accountId: this.selectedAccount,
        filterWarning: filterWarning,
        filterAlert: filterAlert
      });
    },
    fetchList: function fetchList() {
      var _this2 = this;

      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      var searchItem = (this.searchItem || '').trim().length > 0 ? this.searchItem.trim() : undefined;

      if (get(this.priorRequestOptions, 'search') !== searchItem) {
        // if the search-item is changed, reset to page 1
        this.tableOptions = _objectSpread(_objectSpread({}, this.tableOptions), {}, {
          page: 1
        });
      }

      var _this$tableOptions = this.tableOptions,
          sortBy = _this$tableOptions.sortBy,
          sortDesc = _this$tableOptions.sortDesc,
          page = _this$tableOptions.page,
          itemsPerPage = _this$tableOptions.itemsPerPage;
      var sortItem = sortBy && sortBy.length ? sortBy[0] : 'id';
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      var sortDirection = doSortDesc ? 'DESC' : 'ASC';
      var usedPage = Math.max(1, page || 1);
      var usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      var offset = (usedPage - 1) * usedItemsPerPage;
      var newRequestOptions = {
        accountId: this.accountId,
        offset: offset,
        limit: usedItemsPerPage,
        order: {
          variable: sortItem,
          direction: sortDirection
        },
        search: searchItem,
        options: [this.filterWarning ? 'warning' : null, this.filterAlert ? 'alert' : null].filter(function (o) {
          return o;
        }),
        includeSubAccounts: this.includeSubAccounts
      }; // persist options for next call of this page (during this browser-tab-session)

      this.$store.state.app.pageFilters = _objectSpread(_objectSpread({}, this.$store.state.app.pageFilters), {}, {
        GWMgmt: _objectSpread(_objectSpread({}, get(this.$store.state.app, 'pageFilters.GWMgmt') || {}), {}, {
          list: {
            searchDetails: this.searchItem,
            tableOptions: this.tableOptions,
            includeSubAccounts: this.includeSubAccounts,
            accountFilter: this.accountId,
            filterWarning: this.filterWarning,
            filterAlert: this.filterAlert
          }
        })
      });
      this.priorRequestOptions = newRequestOptions;
      ApiService.gwMgmtFetch(newRequestOptions.accountId, newRequestOptions.offset, newRequestOptions.limit, newRequestOptions.order, newRequestOptions.options, newRequestOptions.search, newRequestOptions.includeSubAccounts).then(function (response) {
        _this2.gateways = response.gateways;
        _this2.serverItemsLength = response.totalCount;

        _this2.$emit('refreshed-list');
      }).catch(function (error) {
        _this2.gateways = [];

        _this2.$snack(_this2.$i18n_t('NiotaClassic.GWMonitoring.snacks.errorGatewayDevice'), 'error');

        console.error(error);
      }).finally(function () {
        _this2.isFetching = false;
      });
    },
    localizeDate: function localizeDate(item) {
      if (item) {
        return _localizeDate(item);
      }
    },
    openDetails: function openDetails(item) {
      this.$router.push("/niota-classic/gw-mgmt/".concat(item.id, "/details"));
    },
    isCopySupported: function isCopySupported() {
      return isCopyToClipboardSupported();
    },
    copyToClipboard: function copyToClipboard(event, copyValue) {
      event.stopPropagation();

      _copyToClipboard(copyValue);
    },
    lastPacket: function lastPacket(item) {
      return this.localizeDate(get(item, 'lastPacket._source.received_at_server'));
    },
    getRssi: function getRssi(item) {
      return get(item, 'lastPacket._source.rssi');
    },
    getAccount: function getAccount(item) {
      return get(item, 'account.name');
    },
    getGroup: function getGroup(item) {
      return get(item, 'properties.group');
    },
    deleteItem: function deleteItem() {
      var _this3 = this;

      return ApiService.gwMgmtDelete(this.selectedItem.id).then(function () {
        _this3.$snack(_this3.$i18n_t('NiotaClassic.GWMonitoring.snacks.deleteSuccess'), 'success');

        _this3.deletePrompt = false;

        _this3.fetchList();
      }).catch(function (error) {
        _this3.$snack(_this3.$i18n_t('NiotaClassic.GWMonitoring.snacks.deleteFailed'), 'error');

        console.error(error);
      });
    },
    showPrompt: function showPrompt(item) {
      this.selectedItem = item;
      this.deletePrompt = true;
    },
    getColor: function getColor(type) {
      return vuetifyColors[type];
    },
    getState: function getState(item) {
      var lastPaket = get(item, 'lastPacket._source.received_at_server');
      var green = parseFloat(get(item, 'properties.threshold.green') || 5);
      var yellow = parseFloat(get(item, 'properties.threshold.yellow') || 12); // 36e5 aka 1 hr in ms

      var diff = Math.abs(new Date(lastPaket) - new Date()) / 36e5;

      if (diff < green) {
        return this.getColor('success');
      } else if (diff >= green && diff < yellow) {
        return this.getColor('warning');
      } else {
        return this.getColor('error');
      }
    }
  }
};